/**
 * Master switch for pausing the product. When true, every flow that leads a visitor
 * into an account (login, the account layer, community, the blog CTAs) renders the
 * pause message instead, and nothing links back to the home page. The blogs stay
 * untouched and remain the only content on offer.
 *
 * Every usage keeps the original code as the else branch, so flipping this back to
 * false restores the site as it was.
 */
export const PAUSE_FLAG = true;

export const PAUSE_TITLE = "We'll be back soon";

export const PAUSE_MESSAGE =
  "EcoCount's tracking and community activities are paused for now. We're working through the feedback we've received to make tracking activities genuinely better before we bring them back.";

export const PAUSE_BLOGS_CTA = "Read the blogs";
